import React, { useCallback, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import {
  Backdrop,
  Button,
  FormFieldSet,
  LogoLoader,
  Modal,
  showToast,
  useFormHandler,
  AttachmentSection,
} from "../../../../../../components";

//
import { useDispatch, useSelector } from "react-redux";
import { updateEmployee } from "../../../../../../redux/slices/employee/employeeApi";
import {
  getEmployeeByUiidStart,
  updateEmployeeStart,
} from "../../../../../../redux/slices/employee/employeeSlice";
//
//Form Submission hook
import { useFormSubmission } from "../../../../../../hooks/useFormSubmission";
//Form Submission hook end
//Get Login User data
import { useLoginUser } from "../../../../../../hooks/useLoginUser";
import { uploadStart } from "../../../../../../redux/slices/universal/fileUploadSlice";
import { addDocumentStart } from "../../../../../../redux/slices/universal/documentsSlice";
import { filterEmptyValues } from "../../../../../../utils/filterEmptyValues";
//Get Login User data end

const I140Modal = ({ isOpen, onClose, edit }) => {
  const dispatch = useDispatch();
  const { employeeProfileUiid, currentEmployee } = useSelector(
    (state) => state.employee,
  );
  const { i94 } = currentEmployee.employeeDetails || {};

  // Get the current i94 array length for new entries or use edit index
  const currentI140Length = i94?.i140?.length || 0;
  const documentIndex = edit?.index ?? currentI140Length;
  ///Get login user informatio
  const { userData: loginUserData } = useLoginUser();
  const loginUserUiid = loginUserData?.uiid;
  ///////////////

  //initial Form Data
  const initialFormData = {
    petitionerSponsored: "",
    dateI140Filled: "",
    receiptNumber: "",
    is140Approved: "yes",
    comments: "",
    attachments: [
      {
        id: uuidv4(),
        attachmentName: "",
        attachmentComments: "",
        documentType: "",
        documentStatus: "",
        chooseFiles: [],
      },
    ],
  };

  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(initialFormData, {
      petitionerSponsored: { type: "text", required: true },
      receiptNumber: { type: "text", required: true, number: true },
      attachments: [
        {
          // attachmentName: {
          //   type: "text",
          //   required: true,
          //   minLength: 3,
          // },
          // attachmentComments: {
          //   type: "text",
          //   required: true,
          //   minLength: 3,
          // },
          documentType: {
            type: "text",
            required: true,
            minLength: 3,
          },
          chooseFiles: {
            type: "file",
            required: true,
            // allowedFiles: [
            //   { ext: "pdf", mime: "application/pdf" },
            //   { ext: "doc", mime: "application/msword" },
            //   {
            //     ext: "docx",
            //     mime: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            //   },
            //   { ext: "png", mime: "image/png" },
            //   { ext: "txt", mime: "text/plain" },
            // ],
          },
        },
      ],
    });

  ///////////////////////////////////////////////////
  //handel Attachment Error
  ///////////////////////////////////////////////////

  const getAttachmentError = (index, field) => {
    return errors?.attachments?.[index]?.[field] || "";
  };
  ///////////////////////////////////////////////////
  //handel Attachment Error end
  ///////////////////////////////////////////////////

  const handleSaveI140 = async () => {
    const isValid = validateAllFields();
    if (!isValid) {
      showToast("All mandatory fields must be filled out.", "error");
      return;
    }
    const cleanAttachments = formData.attachments.filter(
      (att) =>
        att.attachmentName.trim() !== "" ||
        att.attachmentComments.trim() !== "" ||
        (att.chooseFiles && att.chooseFiles.length > 0),
    );

    const cleanattachmentsId = cleanAttachments.flatMap((doc) =>
      doc.chooseFiles.map((file) => {
        file.id = doc.id;
        return file;
      }),
    );
    const initialData = {
      petitionerSponser: formData.petitionerSponsored,
      filingDate: formData.dateI140Filled,
      receiptNum: formData.receiptNumber,
      isApproved: formData.is140Approved,
      comments: formData.comments,
      ///
      //
      //
    };
    const submissionData = filterEmptyValues(initialData);
    const payload = edit
      ? [
          {
            type: "PUSH",
            value: {
              [`i140.${edit.index}`]: submissionData,
            },
          },
        ]
      : [
          {
            type: "PUSH",
            value: { i140: submissionData },
          },
        ];
    dispatch(
      updateEmployeeStart({
        coll: "Employee",
        uiid: employeeProfileUiid,
        ...(edit ? {} : { tPath: "i140" }),
        payload,
        onSuccess: async (resPayload) => {
          console.log("payloadpage", resPayload);

          if (cleanattachmentsId?.length) {
            dispatch(
              uploadStart({
                uploadType: "multiple",
                field: "doc",
                uiid: employeeProfileUiid,
                entity: "employees",
                category: "i140",
                coll: "Employee",
                doc: cleanattachmentsId,
                onSuccess: async (fileData) => {
                  const patchRefId = resPayload?.data?.targetPatchId;
                  dispatch(
                    addDocumentStart({
                      coll: "Document",
                      refColl: "Employee",
                      refId: employeeProfileUiid,
                      refField: "i140.$[elem].documents",
                      refPatchId: patchRefId,
                      payload: {
                        addedBy: loginUserUiid,
                        attachments: cleanAttachments.map((obj) => ({
                          parent: { employee: employeeProfileUiid },
                          addedBy: loginUserUiid,
                          docType: obj?.documentType,
                          docStatus: obj?.documentStatus,
                          ref: {
                            id: employeeProfileUiid,
                            entity: "Employee",
                            path: `i140.${patchRefId}.documents`,
                          },
                          file: [
                            {
                              name: obj.attachmentName,
                              comments: obj.attachmentComments,
                              keys: fileData
                                .filter(
                                  (file) =>
                                    file?.fileRefId === obj.id && file.key,
                                )
                                .map((file) => file.key),
                            },
                          ],
                        })),
                      },
                      onSuccess: async () => {
                        dispatch(
                          getEmployeeByUiidStart({
                            uiid: employeeProfileUiid,
                            tab: "i94Tab",
                            ret: "i140",
                            ref: "i94Doc i140Doc",
                          }),
                        );
                        onClose();
                      },
                    }),
                  );
                },
              }),
            );
          }
        },
      }),
    );
  };

  //

  // Reset form to initial values
  const resetForm = useCallback(() => {
    setFormData(initialFormData);
  }, [i94, edit, setFormData]);

  // Initialize form when modal opens or edit status changes
  useEffect(() => {
    resetForm();
  }, [isOpen, edit, resetForm]);

  // Handle modal close with reset
  const handleModalClose = () => {
    resetForm();
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="ADD I-140"
      width="max-w-7xl"
    >
      {/* <div className="grid grid-cols-3 gap-5"> */}
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-4 max-w-7xl">
        <FormFieldSet
          type="text"
          title="Petitioner Sponsored"
          placeholder="Enter Petitioner Sponsored"
          value={formData.petitionerSponsored}
          onChange={(value) => handleChange("petitionerSponsored", value)}
          error={errors.petitionerSponsored}
        />
        <FormFieldSet
          type="datepicker"
          title="Date I-140 Filed"
          placeholder="Select Date I-140 Filed"
          value={formData.dateI140Filled}
          onChange={(value) => handleChange("dateI140Filled", value)}
          error={errors.dateI140Filled}
          showDropdown={false}
        />
        <FormFieldSet
          type="text"
          title="Receipt Number"
          placeholder="Enter Receipt Number"
          value={formData.receiptNumber}
          onChange={(value) => handleChange("receiptNumber", value)}
          error={errors.receiptNumber}
        />
        <FormFieldSet
          type="radio"
          title="Is I-140 Approved ?"
          options={[
            {
              label: "Yes",
              value: "yes",
            },
            { label: "No", value: "no" },
          ]}
          value={formData.is140Approved}
          onChange={(event) =>
            handleChange("is140Approved", event.target.value)
          }
          error={errors.is140Approved}
        />
        <FormFieldSet
          type="textArea"
          title="Comments"
          placeholder="Enter Comments"
          value={formData.comments}
          onChange={(value) => handleChange("comments", value)}
          error={errors.comments}
        />

        <div className="col-span-2 lg:col-span-3">
          <AttachmentSection
            attachments={formData.attachments}
            onChange={(newAttachments) =>
              setFormData({ ...formData, attachments: newAttachments })
            }
            getAttachmentError={getAttachmentError}
            showNameField={true}
            showCommentsField={true}
            showDocumentStatusField
            showDocumentTypeField
          />
        </div>
      </div>
      <div className="flex gap-3 justify-end mt-14">
        <Button title={"cancel"} variant="outlined" onClick={onClose} />
        <Button title={"Save"} onClick={() => handleSaveI140()} />
      </div>
      {/* <Backdrop isOpen={submissionLoading}>
        <LogoLoader />
      </Backdrop> */}
    </Modal>
  );
};

//Update prepareSubmissionData to properly handle city and state
const prepareSubmissionData = (formData) => {
  const initialData = {
    petitionerSponser: formData.petitionerSponsored,
    filingDate: formData.dateI140Filled,
    receiptNum: formData.receiptNumber,
    isApproved: formData.is140Approved,
    comments: formData.comments,
    ///
    //
    //
  };

  return Object.fromEntries(
    Object.entries(initialData).filter(([_, value]) => {
      if (value === null || value === undefined || value === "") return false;
      if (
        value instanceof Date ||
        (typeof value === "string" && value.match(/^\d{4}-\d{2}-\d{2}/))
      )
        return true;
      if (typeof value === "object") return Object.keys(value).length > 0;
      return true;
    }),
  );
};

export default I140Modal;
